// Generated from roles.tokens.json by scripts/generate-role-tokens.mjs. Do not edit.
export const TEXT_ROLES = [
    'caption',
    'meta',
    'ui',
    'body',
    'body-lg',
    'heading',
    'title-sm',
    'title',
    'title-lg',
    'display',
] as const;
export const SPACE_ROLES = [
    'hairline',
    'inline',
    'stack',
    'card',
    'group',
    'panel',
    'subsection',
    'section',
    'page',
] as const;
export const SIZE_ROLES = ['control-sm', 'control', 'control-lg'] as const;
export const WIDTH_ROLES = ['dialog-sm', 'dialog', 'reading', 'form', 'wide'] as const;
